// BSS B2B Net Terms: once the order is created, skip the app's thank-you modal
// and send the customer straight to our own "Order received" page.
const B2B_ORDER_RECEIVED_URL = "/pages/order-received";

// BSS dispatches this on document (after clearing the cart) and renders the modal
// from a document listener. Catching it on window in the capture phase runs first,
// so stopping it here means the modal is never shown.
window.addEventListener("bss_b2b:show_thank_you_modal", function (e) {
    e.stopImmediatePropagation();
    window.location.href = B2B_ORDER_RECEIVED_URL;
}, true);

// BSS strips the checkout button's inline styles on click. When the customer
// returns via the browser back button the button is left non-clickable, so
// restore the styles on pageshow (bfcache) and whenever BSS removes them.
function restoreCheckoutButtons() {
    document.querySelectorAll('button[name="checkout"]').forEach(function (btn) {
        btn.style.setProperty("pointer-events", "unset");
        btn.style.setProperty("cursor", "pointer");
        btn.disabled = false;
        btn.removeAttribute("aria-disabled");
    });
}

window.addEventListener("pageshow", restoreCheckoutButtons);
document.addEventListener("visibilitychange", function () {
    if (!document.hidden) restoreCheckoutButtons();
});
document.addEventListener("DOMContentLoaded", function () {
    restoreCheckoutButtons();
    new MutationObserver(function (mutations) {
        const needsRestore = mutations.some(function (m) {
            return m.target.matches('button[name="checkout"]') &&
                m.target.style.pointerEvents !== "unset";
        });
        if (needsRestore) restoreCheckoutButtons();
    }).observe(document.body, {
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
    });
});

// Fallback in case the modal still appears (e.g. a BSS update changes the event).
document.addEventListener("click", function (e) {
    const actionBtn = e.target.closest(
        "#b2b-nt-thankyou-modal .b2b-nt-button-confirm, #b2b-nt-thankyou-modal .b2b-nt-close-btn"
    );
    if (actionBtn) {
        e.preventDefault();
        e.stopImmediatePropagation();

        window.location.href = B2B_ORDER_RECEIVED_URL;
    }
}, true);
